import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import SectionMessage from '@atlaskit/section-message';
import { hooks } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { promotionDetailsRoute } from "../../../constants/Routes";
import { resolveManagePartnersRoutes } from "../../../utils/routeUtils";
import { PromotionListSectionMessageActions } from "../CreatePromotion/constants";
var useQueryParams = hooks.useQueryParams;

var Banner = _styled("div", {
  target: "euur62q0",
  label: "Banner"
})(process.env.NODE_ENV === "production" ? {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
} : {
  name: "1qm1lh",
  styles: "margin-bottom:16px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9NYW5hZ2VQYXJ0bmVycy9Qcm9tb3Rpb25zL2NvbXBvbmVudHMvUHJvbW90aW9uc0xpc3QvUHJvbW90aW9uc0xpc3RTZWN0aW9uTWVzc2FnZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQnlCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9NYW5hZ2VQYXJ0bmVycy9Qcm9tb3Rpb25zL2NvbXBvbmVudHMvUHJvbW90aW9uc0xpc3QvUHJvbW90aW9uc0xpc3RTZWN0aW9uTWVzc2FnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBTZWN0aW9uTWVzc2FnZSBmcm9tICdAYXRsYXNraXQvc2VjdGlvbi1tZXNzYWdlJztcbmltcG9ydCB7IGhvb2tzIH0gZnJvbSAnQGF0bGFzc2lhbi9tcGFjLXV0aWxzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBSZWFjdCwgeyB1c2VFZmZlY3QsIHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdXNlSGlzdG9yeSB9IGZyb20gJ3JlYWN0LXJvdXRlcic7XG5cbmltcG9ydCB7IHByb21vdGlvbkRldGFpbHNSb3V0ZSB9IGZyb20gJy4uLy4uLy4uL2NvbnN0YW50cy9Sb3V0ZXMnO1xuaW1wb3J0IHsgcmVzb2x2ZU1hbmFnZVBhcnRuZXJzUm91dGVzIH0gZnJvbSAnLi4vLi4vLi4vdXRpbHMvcm91dGVVdGlscyc7XG5pbXBvcnQgeyBQcm9tb3Rpb25MaXN0U2VjdGlvbk1lc3NhZ2VBY3Rpb25zIH0gZnJvbSAnLi4vQ3JlYXRlUHJvbW90aW9uL2NvbnN0YW50cyc7XG5cbmltcG9ydCB0eXBlIHsgUHJvbW90aW9uIH0gZnJvbSAnQGF0bGFzc2lhbi9tcGFjLWFwaS1jbGllbnQnO1xuXG5jb25zdCB7IHVzZVF1ZXJ5UGFyYW1zIH0gPSBob29rcztcblxuY29uc3QgQmFubmVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLWJvdHRvbTogMTZweDtcbmA7XG5cbnR5cGUgUHJvcHMgPSB7XG4gIHBhcnRuZXJJZDogbnVtYmVyLFxuICBwcm9tb3Rpb25zOiBQcm9tb3Rpb25bXSxcbn07XG5cbmNvbnN0IFByb21vdGlvbnNMaXN0U2VjdGlvbk1lc3NhZ2UgPSAocHJvcHM6IFByb3BzKSA9PiB7XG4gIGNvbnN0IGhpc3RvcnkgPSB1c2VIaXN0b3J5KCk7XG4gIGNvbnN0IFtzZWN0aW9uTWVzc2FnZSwgc2V0U2VjdGlvbk1lc3NhZ2VdID0gdXNlU3RhdGUoKTtcbiAgY29uc3QgcXVlcnlQYXJhbXMgPSB1c2VRdWVyeVBhcmFtcygpO1xuXG4gIGNvbnN0IGFkZFNlY3Rpb25NZXNzYWdlRm9yQ3JlYXRlUHJvbW8gPSAocHJvbW90aW9uLCByZW1vdmVRdWVyeVN0cmluZykgPT4ge1xuICAgIHNldFNlY3Rpb25NZXNzYWdlKHtcbiAgICAgIHR5cGU6ICdjb25maXJtYXRpb24nLFxuICAgICAgbWVzc2FnZTogYFlvdXIgcHJvbW90aW9uICR7cHJvbW90aW9uLm5hbWV9IHN1Y2Nlc3NmdWxseSBjcmVhdGVkYCxcbiAgICAgIGFjdGlvbnM6IFtcbiAgICAgICAge1xuICAgICAgICAgIGhyZWY6IHJlc29sdmVNYW5hZ2VQYXJ0bmVyc1JvdXRlcyhwcm9tb3Rpb25EZXRhaWxzUm91dGUucGF0aCwge1xuICAgICAgICAgICAgcGFydG5lcklkOiBwcm9wcy5wYXJ0bmVySWQsXG4gICAgICAgICAgICBwcm9tb3Rpb25JZDogcHJvbW90aW9uLmlkLFxuICAgICAgICAgIH0pLFxuICAgICAgICAgIHRleHQ6ICdWaWV3IHByb21vdGlvbiBkZXRhaWxzJyxcbiAgICAgICAgfSxcbiAgICAgIF0sXG4gICAgfSk7XG4gICAgcmVtb3ZlUXVlcnlTdHJpbmcoKTtcbiAgfTtcblxuICBjb25zdCBhZGRTZWN0aW9uTWVzc2FnZUZvckRlbGV0ZVByb21vID0gKHByb21vdGlvbiwgcmVtb3ZlUXVlcnlTdHJpbmcpID0+IHtcbiAgICBzZXRTZWN0aW9uTWVzc2FnZSh7XG4gICAgICB0eXBlOiAnZXJyb3InLFxuICAgICAgbWVzc2FnZTogYCR7cHJvbW90aW9uLm5hbWV9IGhhcyBlbmRlZCBlYXJseS5gLFxuICAgIH0pO1xuXG4gICAgcmVtb3ZlUXVlcnlTdHJpbmcoKTtcbiAgfTtcblxuICB1c2VFZmZlY3QoXG4gICAgKCkgPT4ge1xuICAgICAgY29uc3QgcmVtb3ZlUXVlcnlTdHJpbmcgPSAoKSA9PlxuICAgICAgICBoaXN0b3J5LnJlcGxhY2Uoe1xuICAgICAgICAgIHBhdGhuYW1lOiBsb2NhdGlvbi5wYXRobmFtZSxcbiAgICAgICAgfSk7XG5cbiAgICAgIGNvbnN0IHByb21vdGlvbklkID0gcXVlcnlQYXJhbXMucHJvbW90aW9uO1xuICAgICAgbGV0IHByb21vdGlvbjtcbiAgICAgIGlmIChwcm9wcy5wcm9tb3Rpb25zLmxlbmd0aCA+IDAgJiYgcHJvbW90aW9uSWQpIHtcbiAgICAgICAgcHJvbW90aW9uID0gcHJvcHMucHJvbW90aW9ucy5maW5kKHByb21vID0+IHByb21vLmlkID09PSBwcm9tb3Rpb25JZCk7XG4gICAgICB9XG4gICAgICBjb25zdCBhY3Rpb24gPSBxdWVyeVBhcmFtcy5hY3Rpb247XG4gICAgICBpZiAocHJvbW90aW9uICYmIGFjdGlvbiA9PT0gUHJvbW90aW9uTGlzdFNlY3Rpb25NZXNzYWdlQWN0aW9ucy5BREQpIHtcbiAgICAgICAgYWRkU2VjdGlvbk1lc3NhZ2VGb3JDcmVhdGVQcm9tbyhwcm9tb3Rpb24sIHJlbW92ZVF1ZXJ5U3RyaW5nKTtcbiAgICAgIH0gZWxzZSBpZiAocHJvbW90aW9uICYmIGFjdGlvbiA9PT0gUHJvbW90aW9uTGlzdFNlY3Rpb25NZXNzYWdlQWN0aW9ucy5FTkRfUFJPTU9USU9OKSB7XG4gICAgICAgIGFkZFNlY3Rpb25NZXNzYWdlRm9yRGVsZXRlUHJvbW8ocHJvbW90aW9uLCByZW1vdmVRdWVyeVN0cmluZyk7XG4gICAgICB9XG4gICAgfSxcbiAgICBbcHJvcHMucHJvbW90aW9uc11cbiAgKTtcblxuICByZXR1cm4gc2VjdGlvbk1lc3NhZ2UgPyAoXG4gICAgPEJhbm5lcj5cbiAgICAgIDxTZWN0aW9uTWVzc2FnZVxuICAgICAgICBhcHBlYXJhbmNlPXtzZWN0aW9uTWVzc2FnZS50eXBlfVxuICAgICAgICB7Li4uc2VjdGlvbk1lc3NhZ2UuYWN0aW9ucyAmJiB7IGFjdGlvbnM6IHNlY3Rpb25NZXNzYWdlLmFjdGlvbnMgfX1cbiAgICAgID5cbiAgICAgICAge3NlY3Rpb25NZXNzYWdlLm1lc3NhZ2V9XG4gICAgICA8L1NlY3Rpb25NZXNzYWdlPlxuICAgIDwvQmFubmVyPlxuICApIDogbnVsbDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFByb21vdGlvbnNMaXN0U2VjdGlvbk1lc3NhZ2U7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var PromotionsListSectionMessage = function PromotionsListSectionMessage(props) {
  var history = useHistory();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      sectionMessage = _useState2[0],
      setSectionMessage = _useState2[1];

  var queryParams = useQueryParams();

  var addSectionMessageForCreatePromo = function addSectionMessageForCreatePromo(promotion, removeQueryString) {
    setSectionMessage({
      type: 'confirmation',
      message: "Your promotion ".concat(promotion.name, " successfully created"),
      actions: [{
        href: resolveManagePartnersRoutes(promotionDetailsRoute.path, {
          partnerId: props.partnerId,
          promotionId: promotion.id
        }),
        text: 'View promotion details'
      }]
    });
    removeQueryString();
  };

  var addSectionMessageForDeletePromo = function addSectionMessageForDeletePromo(promotion, removeQueryString) {
    setSectionMessage({
      type: 'error',
      message: "".concat(promotion.name, " has ended early.")
    });
    removeQueryString();
  };

  useEffect(function () {
    var removeQueryString = function removeQueryString() {
      return history.replace({
        pathname: location.pathname
      });
    };

    var promotionId = queryParams.promotion;
    var promotion;

    if (props.promotions.length > 0 && promotionId) {
      promotion = props.promotions.find(function (promo) {
        return promo.id === promotionId;
      });
    }

    var action = queryParams.action;

    if (promotion && action === PromotionListSectionMessageActions.ADD) {
      addSectionMessageForCreatePromo(promotion, removeQueryString);
    } else if (promotion && action === PromotionListSectionMessageActions.END_PROMOTION) {
      addSectionMessageForDeletePromo(promotion, removeQueryString);
    }
  }, [props.promotions]);
  return sectionMessage ? /*#__PURE__*/React.createElement(Banner, null, /*#__PURE__*/React.createElement(SectionMessage, _extends({
    appearance: sectionMessage.type
  }, sectionMessage.actions && {
    actions: sectionMessage.actions
  }), sectionMessage.message)) : null;
};

export default PromotionsListSectionMessage;